import { Button, Modal, ModalHandle, ModalProps } from '@lfg/ui/components';
import CloseIcon from '@mui/icons-material/Close';
import { Stack, Typography } from '@mui/material';
import { forwardRef, useCallback, useImperativeHandle, useRef } from 'react';

import { colors } from 'src/global/styles/colors';

export interface PublishOtcRequestHandle extends ModalHandle {}

export interface PublishOtcModalProps extends Omit<ModalProps, 'children'> {
  handleCreateOtcSale: () => void;
  loading?: boolean;
  onPublishClick?: () => void;
}
export const PublishOtcModal = forwardRef<PublishOtcRequestHandle, PublishOtcModalProps>(
  ({ handleCreateOtcSale, loading, onPublishClick, ...rest }, ref) => {
    const modalRef = useRef<ModalHandle>(null);
    const onShow = useCallback(() => modalRef.current?.show(), [modalRef.current]);
    const onHide = useCallback(() => modalRef.current?.hide(), [modalRef.current]);

    useImperativeHandle(ref, () => ({ show: onShow, hide: onHide }), [onShow, onHide]);

    return (
      <Modal
        ref={modalRef}
        bgColor={colors.modal}
        sx={{
          maxWidth: '560px',
          width: '100%',
          boxShadow: '0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px 0px rgba(0, 0, 0, 0.30)',
          border: `1px solid ${colors.neutral015}`,
        }}
        {...rest}>
        <Stack gap={3} flexGrow={1}>
          <Stack gap={2} alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
            <Typography component={'h3'} fontSize={'18px'} fontWeight={'500'} color={'white'}>
              Confirm OTC Deal Publication
            </Typography>
            <CloseIcon onClick={onHide} sx={{ color: 'white', cursor: 'pointer' }} />
          </Stack>
          <Typography color='white' className='text-body_m font-gotham'>
            Please ensure all details, including pricing and quantity, are accurate and wish to proceed with your
            publication.
          </Typography>
          <Stack direction={'row'} justifyContent={'end'} alignItems={'center'} spacing={2}>
            <Button
              onClick={onHide}
              sx={{
                padding: '14px 32px',
                borderRadius: '4px !important',
                backgroundColor: `${colors.neutral06} !important`,
                color: 'white',
                display: 'flex',
                justifyContent: 'center',
                gap: '8px',
                alignItems: 'center',
                height: '40px !important',
              }}>
              Cancel
            </Button>
            <Button
              isLoading={loading}
              onClick={() => {
                onPublishClick?.();
                handleCreateOtcSale();
              }}
              bgColor={colors.blue200}
              borderRadius={'4px'}
              sx={{
                width: '140px !important',
                padding: '14px 32px',
                borderRadius: '4px !important',
                backgroundColor: colors.blue200,
                color: 'white',
                display: 'flex',
                justifyContent: 'center',
                gap: '8px',
                alignItems: 'center',
                height: '40px !important',
              }}>
              Publish
            </Button>
          </Stack>
        </Stack>
      </Modal>
    );
  },
);
